export enum ExportType {
    pdf = 'pdf',
    csv = 'csv'
}